import React from 'react';
import { Segment, Form, Button } from 'semantic-ui-react';
import { DateTimePicker } from 'react-widgets';
import 'react-widgets/dist/css/react-widgets.css';

import axios from 'axios';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


// props:
//  printOptionsFiltersSelectedValues
//  printOptionsFiltersAvailableValuesList
//  onPrintOptionsFilterChange (fn)
export default class Options extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            documentReasons: [],
            documentReason: '',
            printOptions: [
                {
                    value: true,
                    key: 'withLogo',
                    text: 'sa logom'
                },
                {
                    value: false,
                    key: 'withoutLogo',
                    text: 'bez loga'
                }
            ]
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getReasons = this.getReasons.bind(this);
    }


    componentDidMount() {
        console.log('Options:     printOptionsFiltersAvailableValuesList', this.props.printOptionsFiltersAvailableValuesList);
    }

    getReasons(id) {
        axios.get('/document-reasons/get-reasons/' + id)
            .then(res => {
                if (res.data.length === 0) {
                    return;
                }
                const documentReasons = res.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));
                this.setState({ documentReasons, documentReason: documentReasons[0].id });
            })
            .catch(err => { console.log('Failed to fetch reasons'); });
    }

    handleInputChange(event, { name, value }) {
        this.props.onPrintOptionsFilterChange(name, value);
        // if (name === 'documentType') { this.getReasons(value); }
    }

    handleChange(event) {
        event.preventDefault();
        const { target } = event;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const { name } = target;

        this.props.onPrintOptionsFilterChange(name, value);
    }
    handleDateChange(name, date) {
        this.props.onPrintOptionsFilterChange(name, date);
    }
    render() {
        const {
            issueDate,
            documentType,
            documentReason,
            language,
            withLogo
        } = this.props.printOptionsFiltersSelectedValues;
        const {
            documentTypes,
            documentReasons,
            languages
        } = this.props.printOptionsFiltersAvailableValuesList;
        const { printOptions } = this.state;
        return (
            <div>
                <Segment.Group raised>
                    <Segment>
                        <h3>Opcije za štampanje</h3>
                    </Segment>
                    <Segment clearing>
                        <Form>
                            <Form.Field>
                                <label>Vrsta dokumenta</label>
                                <Form.Select
                                    value={documentType}
                                    onChange={this.handleInputChange}
                                    name="documentType"
                                    options={documentTypes}
                                    search
                                    fluid
                                />
                            </Form.Field>
                        </Form>
                        <br />
                        <Form>
                            <Form.Field>

                                <label>Izgled dokumenta</label>
                                <Form.Select
                                    value={withLogo}
                                    onChange={this.handleInputChange}
                                    name="withLogo"
                                    options={printOptions}
                                    search
                                    fluid
                                />
                            </Form.Field>
                        </Form>
                        <br />
                        <Form>
                            <Form.Field>
                                <label>Razlog štampanja</label>
                                <Form.Select
                                    value={this.state.documentReason ? this.state.documentReason : documentReason}
                                    onChange={this.handleInputChange}
                                    name="documentReason"
                                    options={this.state.documentReasons.length ? this.state.documentReasons : documentReasons}
                                    search
                                    fluid
                                    // disabled={documentTypes.find(el => el.text === 'Uvjerenje o završenom ciklusu studija').id === documentType}
                                />
                            </Form.Field>
                        </Form>

                        <br />
                        <Form>
                            <Form.Field>

                                <label>Jezik</label>
                                <Form.Select
                                    value={language}
                                    onChange={this.handleInputChange}
                                    name="language"
                                    options={languages}
                                    search
                                    fluid
                                />
                            </Form.Field>
                        </Form>
                        <br />
                        <Form.Field>
                            <label>Datum izdavanja</label>
                            <DateTimePicker
                                format="D. M. YYYY."
                                defaultValue={new Date()}
                                time={false}
                                onChange={this.handleDateChange.bind(null, 'issueDate')}
                                value={issueDate}
                            />
                        </Form.Field>
                        <br />
                        <Button color="blue" basic="true" floated="left" onClick={() => this.props.changeWizardStep('prev')}>Nazad</Button>
                        <Button color="blue" floated="right" onClick={() => this.props.changeWizardStep('next')}>Prikaži studente</Button>

                    </Segment>
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/DegreeDocumentPrint/Options.js